export default __webpack_public_path__ + "static/assets/e7f5e2898ca055d3662e27024245ce7b.png";